import type { NavItem, SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Gashi Holding',
    description: 'Unternehmerische Beteiligungsgesellschaft aus Mainz-Kastel: Wir beteiligen uns an Unternehmen, entwickeln Geschäftsmodelle weiter und verbinden Menschen und Märkte.',
    url: 'https://gashi-holding.de',
    locale: 'de_DE',
    ogImage: 'https://gashi-holding.de/api/og'
}

export const company = {
    legalName: 'Gashi Holding GmbH',
    street: 'Peter-Sander-Straße 43b',
    postalCode: '55252',
    city: 'Mainz-Kastel',
    country: 'Deutschland',
    registerCourt: 'Amtsgericht Wiesbaden',
    registerNumber: 'HRB 35275',
    domain: 'gashi-holding.de'
}

export const mainNavigation: Array<NavItem> = [
    { label: 'Profil', href: '/#profil' },
    { label: 'Cases', href: '/#cases' },
    { label: 'Kompetenzen', href: '/#kompetenzen' },
    { label: 'Netzwerk', href: '/#netzwerk' },
    { label: 'Kontakt', href: '/#kontakt' }
]

export const legalNavigation: Array<NavItem> = [
    { label: 'Impressum', href: '/impressum' },
    { label: 'Datenschutz', href: '/datenschutz' },
    { label: 'Barrierefreiheit', href: '/barrierefreiheit' }
]

export const primaryCta: NavItem = {
    label: 'Gespräch anfragen',
    href: '/#kontakt'
}
